import React, { useEffect, useState } from "react";
import { Bell, CalendarCheck, MessageCircle } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import InstallAppButton from "./InstallAppButton";
import PhoneMockup from "./PhoneMockup";

const PERKS = [
  { icon: CalendarCheck, title: "Your daily plan", body: "Training, meals and recovery — tick off each pillar as you go." },
  { icon: MessageCircle, title: "Coach in your pocket", body: "Sessions, labs and feedback from your coach, always on hand." },
  { icon: Bell, title: "Gentle nudges", body: "Timely reminders in your timezone, never noise." },
];

export default function GetTheApp() {
  const [url, setUrl] = useState("");
  useEffect(() => setUrl(`${window.location.origin}/m/home`), []);

  return (
    <section className="relative bg-[var(--lc-ink)] text-[var(--lc-cream)] overflow-hidden" data-testid="get-the-app-section">
      <div className="absolute -right-40 top-10 w-[520px] h-[520px] rounded-full border border-white/5" />
      <div className="absolute -right-20 top-32 w-[360px] h-[360px] rounded-full border border-white/5" />
      <div className="relative mx-auto max-w-[1400px] px-5 lg:px-10 py-20 lg:py-28 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-7 fade-up">
          <div className="eyebrow text-[var(--lc-sand)] mb-5">The LONGEV app · Members</div>
          <h2 className="font-serif-display text-[clamp(36px,5vw,72px)] leading-[1] font-light">
            Your circle, <span className="italic">in your pocket.</span>
          </h2>
          <p className="mt-6 max-w-lg text-[15px] leading-relaxed text-white/70">
            One tap from your home screen. No app store, no downloads — install straight from your browser
            on iPhone or Android.
          </p>

          <div className="mt-10 grid sm:grid-cols-3 gap-6">
            {PERKS.map(({ icon: Icon, title, body }) => (
              <div key={title} className="border-t border-white/15 pt-4">
                <Icon className="h-4 w-4 text-[var(--lc-sand)]" />
                <div className="mt-3 font-serif-display text-lg leading-tight">{title}</div>
                <p className="mt-1.5 text-[13px] leading-relaxed text-white/60">{body}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-6">
            <div className="hidden md:flex items-center gap-4 bg-[var(--lc-cream)] p-3 pr-5" data-testid="get-app-qr">
              {url && (
                <QRCodeSVG value={url} size={96} fgColor="#0E1814" bgColor="#F5F1E8" level="M" title="Scan to install the LONGEV app" data-testid="get-app-qr-image" />
              )}
              <div className="text-[var(--lc-ink)]">
                <div className="eyebrow text-[var(--lc-moss)]">Scan with your phone</div>
                <div className="font-serif-display text-lg leading-tight mt-1">Point camera, tap, install.</div>
              </div>
            </div>
            <InstallAppButton label="Get the app" className="!px-7 !py-4" testId="get-app-install-btn" />
          </div>
        </div>

        <div className="lg:col-span-5 flex justify-center lg:justify-end">
          <PhoneMockup />
        </div>
      </div>
    </section>
  );
}
